import axios from 'axios';
import { Dispatch } from 'react-redux';

import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import { navigateToAffiliateProgramRewards } from './navigationActions';
import { fetchAffiliateProgramPartners } from './affiliateProgramPartnerActions';

import ResponseStatus from '../utils/responseStatus';
import affiliateProgramRewardItemTransformationBeforeSave from '../data-transformations/affiliateProgramRewardItemTransformationBeforeSave';
import { fetchRewards } from './rewardActions';
import { isLoaded } from '../reducers/affiliateProgramRewardsReducer';

export const fetchAffiliateProgramRewards = () => async (dispatch: Dispatch<any>, getState: any) => {
    if (isLoaded(getState())) {
        return;
    }

    try {
        dispatch(beginAjaxCall());

        const response = await axios.get(`affiliateProgramReward/`);

        if (ResponseStatus.IsOK(response.status)) {
            dispatch({
                type: types.AFFILIATE_PROGRAM_REWARDS_FETCH,
                data: response.data,
            });
        } else {
            dispatch(ajaxCallError());
        }
    } catch (error) {
        dispatch(ajaxCallError());
        throw error;
    }
};

export const createAffiliateProgramReward = (data: any) => (dispatch: any) => {
    dispatch(beginAjaxCall());

    const transformedData = affiliateProgramRewardItemTransformationBeforeSave(data);

    axios
        .post(`affiliateProgramReward`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsCreated(response.status)) {
                dispatch({
                    type: types.AFFILIATE_PROGRAM_REWARDS_ADD,
                });

                dispatch(navigateToAffiliateProgramRewards());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};

export const updateAffiliateProgramReward = (data: any) => (dispatch: any) => {
    dispatch(beginAjaxCall());

    const transformedData = affiliateProgramRewardItemTransformationBeforeSave(data);

    axios
        .put(`affiliateProgramReward`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsOK(response.status)) {
                dispatch({
                    type: types.AFFILIATE_PROGRAM_REWARDS_UPDATE,
                    data: response.data,
                });

                dispatch(navigateToAffiliateProgramRewards());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};

export const fetchAffiliateProgramRewardDependencies = () => async (dispatch: any, getState: any) => {
    try {
        dispatch(LOADING_DEPENDENCIES_BEGIN);

        await fetchAffiliateProgramPartners()(dispatch, getState);
        await fetchRewards()(dispatch, getState);
    } catch (exception) {
        throw exception; //FUJ
    } finally {
        dispatch(LOADING_DEPENDENCIES_END);
    }
};

const LOADING_DEPENDENCIES_BEGIN = {
    type: types.AFFILIATE_PROGRAM_REWARDS_LOADING_DEPENDENCIES_BEGIN,
};

const LOADING_DEPENDENCIES_END = {
    type: types.AFFILIATE_PROGRAM_REWARDS_LOADING_DEPENDENCIES_END,
};
